import { render, staticRenderFns } from "./ChartingWorkspacePage.vue?vue&type=template&id=99897b54&scoped=true&"
import script from "./ChartingWorkspacePage.vue?vue&type=script&lang=js&"
export * from "./ChartingWorkspacePage.vue?vue&type=script&lang=js&"
import style0 from "./ChartingWorkspacePage.vue?vue&type=style&index=0&id=99897b54&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99897b54",
  null
  
)

export default component.exports